export interface CurrencyOption {
  code: string;
  label: string;
  symbol: string;
  country: string;
}

export const CURRENCIES: CurrencyOption[] = [
  { code: 'USD', label: 'USD - US Dollar',                    symbol: '$',    country: 'United States' },
  { code: 'EUR', label: 'EUR - Euro',                          symbol: '€',    country: 'Eurozone' },
  { code: 'GBP', label: 'GBP - British Pound',                symbol: '£',    country: 'United Kingdom' },
  { code: 'JPY', label: 'JPY - Japanese Yen',                  symbol: '¥',    country: 'Japan' },
  { code: 'CAD', label: 'CAD - Canadian Dollar',               symbol: 'C$',   country: 'Canada' },
  { code: 'AUD', label: 'AUD - Australian Dollar',             symbol: 'A$',   country: 'Australia' },
  { code: 'CHF', label: 'CHF - Swiss Franc',                   symbol: 'Fr',   country: 'Switzerland' },
  { code: 'CNY', label: 'CNY - Chinese Yuan',                  symbol: '¥',    country: 'China' },
  { code: 'HKD', label: 'HKD - Hong Kong Dollar',              symbol: 'HK$',  country: 'Hong Kong' },
  { code: 'NZD', label: 'NZD - New Zealand Dollar',            symbol: 'NZ$',  country: 'New Zealand' },
  { code: 'SEK', label: 'SEK - Swedish Krona',                 symbol: 'kr',   country: 'Sweden' },
  { code: 'NOK', label: 'NOK - Norwegian Krone',               symbol: 'kr',   country: 'Norway' },
  { code: 'DKK', label: 'DKK - Danish Krone',                  symbol: 'kr',   country: 'Denmark' },
  { code: 'SGD', label: 'SGD - Singapore Dollar',              symbol: 'S$',   country: 'Singapore' },
  { code: 'MXN', label: 'MXN - Mexican Peso',                  symbol: '$',    country: 'Mexico' },
  { code: 'BRL', label: 'BRL - Brazilian Real',                symbol: 'R$',   country: 'Brazil' },
  { code: 'INR', label: 'INR - Indian Rupee',                  symbol: '₹',    country: 'India' },
  { code: 'RUB', label: 'RUB - Russian Ruble',                 symbol: '₽',    country: 'Russia' },
  { code: 'TRY', label: 'TRY - Turkish Lira',                  symbol: '₺',    country: 'Turkey' },
  { code: 'ZAR', label: 'ZAR - South African Rand',            symbol: 'R',    country: 'South Africa' },
  { code: 'KES', label: 'KES - Kenyan Shilling',               symbol: 'KSh',  country: 'Kenya' },
  { code: 'NGN', label: 'NGN - Nigerian Naira',                symbol: '₦',    country: 'Nigeria' },
  { code: 'GHS', label: 'GHS - Ghanaian Cedi',                 symbol: 'GH₵',  country: 'Ghana' },
  { code: 'TZS', label: 'TZS - Tanzanian Shilling',            symbol: 'TSh',  country: 'Tanzania' },
  { code: 'UGX', label: 'UGX - Ugandan Shilling',              symbol: 'USh',  country: 'Uganda' },
  { code: 'ETB', label: 'ETB - Ethiopian Birr',                symbol: 'Br',   country: 'Ethiopia' },
  { code: 'RWF', label: 'RWF - Rwandan Franc',                 symbol: 'FRw',  country: 'Rwanda' },
  { code: 'XOF', label: 'XOF - West African CFA Franc',        symbol: 'CFA',  country: 'West Africa' },
  { code: 'XAF', label: 'XAF - Central African CFA Franc',     symbol: 'FCFA', country: 'Central Africa' },
  { code: 'EGP', label: 'EGP - Egyptian Pound',                symbol: 'E£',   country: 'Egypt' },
  { code: 'MAD', label: 'MAD - Moroccan Dirham',               symbol: 'MAD',  country: 'Morocco' },
  { code: 'TND', label: 'TND - Tunisian Dinar',                symbol: 'DT',   country: 'Tunisia' },
  { code: 'DZD', label: 'DZD - Algerian Dinar',                symbol: 'DA',   country: 'Algeria' },
  { code: 'MZN', label: 'MZN - Mozambican Metical',            symbol: 'MT',   country: 'Mozambique' },
  { code: 'ZMW', label: 'ZMW - Zambian Kwacha',                symbol: 'ZK',   country: 'Zambia' },
  { code: 'BWP', label: 'BWP - Botswana Pula',                 symbol: 'P',    country: 'Botswana' },
  { code: 'NAD', label: 'NAD - Namibian Dollar',               symbol: 'N$',   country: 'Namibia' },
  { code: 'ZWL', label: 'ZWL - Zimbabwean Dollar',             symbol: 'Z$',   country: 'Zimbabwe' },
  { code: 'AED', label: 'AED - UAE Dirham',                    symbol: 'د.إ',  country: 'United Arab Emirates' },
  { code: 'SAR', label: 'SAR - Saudi Riyal',                   symbol: '﷼',    country: 'Saudi Arabia' },
  { code: 'QAR', label: 'QAR - Qatari Riyal',                  symbol: '﷼',    country: 'Qatar' },
  { code: 'KWD', label: 'KWD - Kuwaiti Dinar',                 symbol: 'KD',   country: 'Kuwait' },
  { code: 'BHD', label: 'BHD - Bahraini Dinar',                symbol: '.د.ب', country: 'Bahrain' },
  { code: 'OMR', label: 'OMR - Omani Rial',                    symbol: '﷼',    country: 'Oman' },
  { code: 'JOD', label: 'JOD - Jordanian Dinar',               symbol: 'JD',   country: 'Jordan' },
  { code: 'ILS', label: 'ILS - Israeli New Shekel',            symbol: '₪',    country: 'Israel' },
  { code: 'LBP', label: 'LBP - Lebanese Pound',                symbol: 'ل.ل',  country: 'Lebanon' },
  { code: 'PKR', label: 'PKR - Pakistani Rupee',               symbol: '₨',    country: 'Pakistan' },
  { code: 'BDT', label: 'BDT - Bangladeshi Taka',              symbol: '৳',    country: 'Bangladesh' },
  { code: 'LKR', label: 'LKR - Sri Lankan Rupee',              symbol: '₨',    country: 'Sri Lanka' },
  { code: 'NPR', label: 'NPR - Nepalese Rupee',                symbol: '₨',    country: 'Nepal' },
  { code: 'MYR', label: 'MYR - Malaysian Ringgit',             symbol: 'RM',   country: 'Malaysia' },
  { code: 'IDR', label: 'IDR - Indonesian Rupiah',             symbol: 'Rp',   country: 'Indonesia' },
  { code: 'PHP', label: 'PHP - Philippine Peso',               symbol: '₱',    country: 'Philippines' },
  { code: 'THB', label: 'THB - Thai Baht',                     symbol: '฿',    country: 'Thailand' },
  { code: 'VND', label: 'VND - Vietnamese Dong',               symbol: '₫',    country: 'Vietnam' },
  { code: 'KRW', label: 'KRW - South Korean Won',              symbol: '₩',    country: 'South Korea' },
  { code: 'TWD', label: 'TWD - New Taiwan Dollar',             symbol: 'NT$',  country: 'Taiwan' },
  { code: 'PLN', label: 'PLN - Polish Zloty',                  symbol: 'zł',   country: 'Poland' },
  { code: 'CZK', label: 'CZK - Czech Koruna',                  symbol: 'Kč',   country: 'Czech Republic' },
  { code: 'HUF', label: 'HUF - Hungarian Forint',              symbol: 'Ft',   country: 'Hungary' },
  { code: 'RON', label: 'RON - Romanian Leu',                  symbol: 'lei',  country: 'Romania' },
  { code: 'HRK', label: 'HRK - Croatian Kuna',                 symbol: 'kn',   country: 'Croatia' },
  { code: 'BGN', label: 'BGN - Bulgarian Lev',                 symbol: 'лв',   country: 'Bulgaria' },
  { code: 'UAH', label: 'UAH - Ukrainian Hryvnia',             symbol: '₴',    country: 'Ukraine' },
  { code: 'ARS', label: 'ARS - Argentine Peso',                symbol: '$',    country: 'Argentina' },
  { code: 'CLP', label: 'CLP - Chilean Peso',                  symbol: '$',    country: 'Chile' },
  { code: 'COP', label: 'COP - Colombian Peso',                symbol: '$',    country: 'Colombia' },
  { code: 'PEN', label: 'PEN - Peruvian Sol',                  symbol: 'S/.',  country: 'Peru' },
  { code: 'VES', label: 'VES - Venezuelan Bolívar',            symbol: 'Bs.',  country: 'Venezuela' },
  { code: 'GTQ', label: 'GTQ - Guatemalan Quetzal',            symbol: 'Q',    country: 'Guatemala' },
  { code: 'CRC', label: 'CRC - Costa Rican Colón',             symbol: '₡',    country: 'Costa Rica' },
  { code: 'DOP', label: 'DOP - Dominican Peso',                symbol: 'RD$',  country: 'Dominican Republic' },
  { code: 'TTD', label: 'TTD - Trinidad & Tobago Dollar',      symbol: 'TT$',  country: 'Trinidad and Tobago' },
  { code: 'JMD', label: 'JMD - Jamaican Dollar',               symbol: 'J$',   country: 'Jamaica' },
];

export const DEFAULT_CURRENCY = 'USD';

// Module-level cache — populated once per session, cleared on settings save
let _cachedCurrency: string | null = null;

export function setCachedCurrency(code: string): void {
  _cachedCurrency = code;
}

export function clearCurrencyCache(): void {
  _cachedCurrency = null;
}

export function getCachedCurrency(): string {
  return _cachedCurrency ?? DEFAULT_CURRENCY;
}

export async function loadOrgCurrency(): Promise<string> {
  if (_cachedCurrency) return _cachedCurrency;
  try {
    const { authService } = await import('../services/auth.service');
    const profile = await authService.getUserProfile();
    const orgId = profile?.organization?.id;
    if (!orgId) return DEFAULT_CURRENCY;
    const { organizationService } = await import('../services/organization.service');
    const org = await organizationService.getOrganization(orgId);
    _cachedCurrency = org.currency || DEFAULT_CURRENCY;
    return _cachedCurrency;
  } catch {
    return DEFAULT_CURRENCY;
  }
}

export function formatCurrencyCompact(amount: number, currencyCode?: string): string {
  const code = (currencyCode ?? _cachedCurrency ?? DEFAULT_CURRENCY).toUpperCase();
  const symbol = CURRENCIES.find((c) => c.code === code)?.symbol ?? code;
  if (amount >= 1_000_000) return `${symbol}${(amount / 1_000_000).toFixed(1)}M`;
  if (amount >= 1_000) return `${symbol}${(amount / 1_000).toFixed(1)}K`;
  return formatCurrency(amount, code);
}

export function formatCurrency(amount: number, currencyCode?: string): string {
  const code = (currencyCode ?? _cachedCurrency ?? DEFAULT_CURRENCY).toUpperCase();
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${code} ${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}
